// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2JzlX","title":"styles_title__1fM8K"};